import { crmRequest } from '../http'
import type { CategoryScope, CrmCategory, CrmManagedLabel } from './types'

export function listCategories(scope: CategoryScope): Promise<CrmCategory[]> {
  return crmRequest(`/categories?scope=${scope}`)
}

export function createCategory(input: {
  scope: CategoryScope
  name: string
  color?: string
  icon?: string
}): Promise<CrmCategory> {
  return crmRequest('/categories', { method: 'POST', body: JSON.stringify(input) })
}

export function updateCategory(
  id: string,
  patch: { name?: string; color?: string; icon?: string; description?: string | null },
): Promise<CrmCategory> {
  return crmRequest(`/categories/${id}`, { method: 'PATCH', body: JSON.stringify(patch) })
}

export function reorderCategories(scope: CategoryScope, ids: string[]): Promise<CrmCategory[]> {
  return crmRequest('/categories/reorder', {
    method: 'POST',
    body: JSON.stringify({ scope, ids }),
  })
}

/** In use: pass a replacement or `clear` ("Geen categorie"); otherwise the API answers 409. */
export function deleteCategory(
  id: string,
  choice: { replacementId?: string; clear?: boolean } = {},
): Promise<void> {
  const query = new URLSearchParams()
  if (choice.replacementId) query.set('replacement_id', choice.replacementId)
  if (choice.clear) query.set('clear', 'true')
  const qs = query.toString()
  return crmRequest(`/categories/${id}${qs ? `?${qs}` : ''}`, { method: 'DELETE' })
}

export function listManagedLabels(): Promise<CrmManagedLabel[]> {
  return crmRequest('/labels')
}

export function addLabel(input: {
  name: string
  color?: string
  icon?: string | null
}): Promise<CrmManagedLabel> {
  return crmRequest('/labels', { method: 'POST', body: JSON.stringify(input) })
}

export function updateLabel(
  id: string,
  patch: { name?: string; color?: string; icon?: string | null },
): Promise<CrmManagedLabel> {
  return crmRequest(`/labels/${id}`, { method: 'PATCH', body: JSON.stringify(patch) })
}

export function deleteLabel(id: string): Promise<void> {
  return crmRequest(`/labels/${id}`, { method: 'DELETE' })
}

export function restoreLabel(id: string): Promise<CrmManagedLabel> {
  return crmRequest(`/labels/${id}/restore`, { method: 'POST' })
}
